import { render, staticRenderFns } from "./PaymentLinkAccount.vue?vue&type=template&id=1b822450&scoped=true&"
import script from "./PaymentLinkAccount.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkAccount.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLinkAccount.vue?vue&type=style&index=0&id=1b822450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b822450",
  null
  
)

export default component.exports